import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import React, { useState } from 'react';
import Loader from '../../../Components/Loader/LoaderComponent.component';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { httpCreateManagerOrUser } from '../../../Hooks/company/company.post.hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpEmployeeSignupEmail } from '../../../Hooks/company/company.post.hooks';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
const CreateManagerEmployeeSubmit = ({ user, type }) => {
  const [result, setResult] = useState('');
  const [emailSent, setEmailSent] = useState('');
  const [userCreated, setUserCreated] = useState(false); // Track if the user has been created
  const { id } = useParams();

  const queryClient = useQueryClient();
  const createMutation = useMutation({
    mutationFn: ({ fullUser, id }) => httpCreateManagerOrUser(fullUser, id),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['managers', 'employees']);
      setResult(message.msg || 'Company has been created');
      setUserCreated(true);
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error creating company:', error);
      setResult(err.msg || 'Failed to create company');
    },
  });
  const emailMutation = useMutation({
    mutationFn: ({ email, password, id }) =>
      httpEmployeeSignupEmail(email, password, id),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['managers', 'employees']);
      setResult(message.msg || 'Company has been created');
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error creating company:', error);
      setResult(err.msg || 'Failed to create company');
    },
  });

  const createManager = async (e) => {
    e.preventDefault();
    const requiredFields = ['firstName', 'lastName', 'email', 'password'];
    const missingFields = requiredFields.filter(
      (field) => !user[field]?.trim()
    );
    if (missingFields.length > 0) {
      alert(`The following fields are missing: ${missingFields.join(', ')}`);
      return; // Stop execution if validation fails
    }
    setResult('Creating Employee/Manager...');
    const fullUser = {
      ...user,
      type,
      company: [
        {
          companyId: id,
          permissions: [],
          role: type === 'Manager' ? 'Manager' : 'Employee',
        },
      ],
    };
    createMutation.mutate({ fullUser, id });
  };

  // Function to send the email
  const sendEmail = async () => {
    setEmailSent('Sending the email...');
    const fullUser = {
      ...user,
      type,
      company: [
        {
          companyId: id,
          permissions: [],
          role: type === 'Manager' ? 'Manager' : 'Employee',
        },
      ],
    };
    emailMutation.mutate({
      email: fullUser.email,
      password: fullUser.password,
      id,
    });
  };

  return (
    <SubmitContainer>
      <TopSubmit>
        {result?.length > 0 && <p className="result">{result}</p>}
        {emailSent?.length > 0 && <p className="result">{emailSent}</p>}
      </TopSubmit>
      <BottomSubmit>
        {createMutation.isPending ? (
          <Loader />
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <PrimaryButton
              functionName={createManager}
              span="Create Employee"
            />
            {userCreated && (
              <PrimaryButton
                functionName={sendEmail}
                span="Send Login Details"
              />
            )}
          </div>
        )}
      </BottomSubmit>
      <span className="italicSpan m1T">
        Email will users login detals, are NOT sent to user automatically
      </span>
    </SubmitContainer>
  );
};

CreateManagerEmployeeSubmit.propTypes = {
  user: PropTypes.object,
  type: PropTypes.string,
};

export default CreateManagerEmployeeSubmit;
